/*
 * Author: Dw
 * File Created: Friday, 24-07-12 03:43 pm
 * Last Modified: Tuesday, 24-11-19 02:54 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function ArrowRight() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="ArrowRight" data-sentry-source-file="index.tsx">
      <path d="M12.1692 18.4973C11.8178 18.8488 11.8178 19.4186 12.1692 19.7701C12.5207 20.1216 13.0906 20.1216 13.442 19.7701L20.5127 12.6995C20.8641 12.348 20.8646 11.7777 20.5131 11.4262L13.442 4.35516C13.0906 4.00369 12.5207 4.00368 12.1692 4.35516C11.8178 4.70663 11.8178 5.27648 12.1692 5.62795L17.6031 11.0618L4.14952 11.0617C3.65246 11.0617 3.24952 11.4647 3.24951 11.9617C3.24951 12.4588 3.65245 12.8617 4.14951 12.8617L17.8047 12.8618L12.1692 18.4973Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default ArrowRight;